import { gql } from '@apollo/client';
import {
  COMPLETED_TASK_FRAGMENT,
  TASK_FORM_ITEM_FRAGMENT,
} from '../../../../../common/form/task-form/model/task-items.gql';

export const GET_VOLUNTEER_TASKS_SECTION_TASK = gql`
  query GetVolunteerTasksSectionTask(
    $completedTaskId: String!
    $taskId: String!
    # $userId: String!
    $profileId: String!
  ) {
    vm {
      profile(profileId: $profileId) {
        userId
        preferredName
        firstName
        lastName
        contactNumber
        dateOfBirth
        programs {
          name
        }
      }
      # application(userId: $userId) {
      #   relevantTasks {
      #     cake {
      #       cakeType
      #     }
      #   }
      # }
      completedTask(completedTaskId: $completedTaskId) {
        ...CompletedTask
        refereeContacts {
          completedTaskRefereeContactId
          refereeOrder
          refereeName
          refereeEmail
          refereePhone
          submissionToken
          dateContactProvided
          dateInvited
          dateSubmitted
          isCompleted
          refereeMessage
          submissionData
        }
        events {
          completedTaskEventId
          message
          scheduledDateTime
          startDateTime
          endDateTime
          timezone
          status
          placesAddress {
            placesId
            formatted
            description
          }
          remoteLocation
          managers {
            managerId
            profile {
              preferredName
              lastName
            }
          }
          participantFeedback
          rescheduleCount
          originalScheduledDate
          dateCreated
        }
      }
      task(taskId: $taskId) {
        taskId
        title
        description
        adminOnly
        isRefereeCheckTask
        isEventTask
        cake {
          title
        }
        taskItems {
          ...TaskFormItem
        }
      }
    }
  }

  ${COMPLETED_TASK_FRAGMENT}
  ${TASK_FORM_ITEM_FRAGMENT}
`;
